export default "__VITE_ASSET__xVcbh47e__"